import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
//import { FormattedMessage } from 'react-intl';

import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.catalog.actions';
import * as actionsHome from '../../../../actions/process.home.actions';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Catalog from './Catalog';

function getFilteredData(list, info, session) {
    const id = session && session.info ? session.info.id : undefined;
    const roles =
        info && info.security && info.security.totalPermits ? info.security.totalPermits : [];
    if (roles.some((f) => f === '20')) {
        return [...list];
    }
    return [...list].reduce((arr, f) => {
        try {
            if (
                (f.permisos &&
                    f.permisos.ed &&
                    f.permisos.ed.usuarios.length === 0 &&
                    f.permisos.ed.roles.length === 0) ||
                (f.permisos && f.permisos.ed && f.permisos.ed.usuarios.some((u) => u.id === id)) ||
                (f.permisos &&
                    f.permisos.ed &&
                    f.permisos.ed.roles.some((r) => roles.some((ur) => parseInt(ur, 10) === r.id)))
            ) {
                arr.push(f);
            }
        } catch (ex) {
            console.error(ex);
        }
        return arr;
    }, []);
}

class ListCatalogs extends React.Component {
    state = {
        catalogs: getFilteredData(this.props.catalogs, this.props.info, this.props.session),
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    static getDerivedStateFromProps(props, state) {
        if (props.catalogs !== state.catalogs) {
            state.catalogs = getFilteredData(props.catalogs, props.info, props.session);
            return state;
        }
        return null;
    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    render() {
        const { catalogs } = this.state;
        const { catalog_is_loading, catalog_has_error } = this.props;
        const data = [...catalogs];

        if (catalog_has_error.hasErrored) {
            return <Error open message={catalog_has_error.error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9 padding_top_12 height100'}>
                    {catalog_is_loading && <Loading open opacity />}
                    <div className="flex_full overflow_y_scroll" onScroll={this.handleScroll}>
                        {data.map((u) => {
                            return <Catalog key={randomstring()} catalog={u} />;
                        })}
                    </div>
                </div>
            );
        }
    }
}

ListCatalogs.propTypes = {
    catalogs: PropTypes.array.isRequired,
    catalog_is_loading: PropTypes.bool.isRequired,
    catalog_has_error: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        catalogs: state.catalogs,
        catalog_is_loading: state.catalog_is_loading,
        catalog_has_error: state.catalog_has_error,
        info: state.info,
        session: state.session,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsHome), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(ListCatalogs));



// WEBPACK FOOTER //
// ./src/components/complex/manage/catalogs/List.js